export default {"src":"/planos/_next/static/media/equifax-file-check.6d4db08e.svg","height":32,"width":26,"blurWidth":0,"blurHeight":0};